"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Form_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = void 0;
const typeorm_1 = require("typeorm/browser");
const data_ui_1 = require("../../data-ui");
const layouts_1 = require("../../data-ui/layouts");
const events_1 = require("../../events");
const contact_profile_enum_1 = require("../contact-profile-enum");
const form_flow_1 = require("./form-flow");
const form_import_1 = require("./form-import");
const form_lang_1 = require("./form-lang");
const form_opportunity_1 = require("./form-opportunity");
const form_order_creation_strategy_1 = require("./form-order-creation-strategy");
const form_order_modification_strategy_1 = require("./form-order-modification-strategy");
const form_settings_1 = require("./form-settings");
const form_strategy_1 = require("./form-strategy");
const order_form_formula_mapping_1 = require("./order-form-formula-mapping");
let Form = Form_1 = class Form {
};
Form.EVENTS = (0, events_1.makeEventsForClass)(Form_1);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.PrimaryGeneratedColumn)('uuid'),
    __metadata("design:type", String)
], Form.prototype, "id", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)('character varying', {
        nullable: false,
        length: 255,
    }),
    __metadata("design:type", String)
], Form.prototype, "name", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        name: 'api_name',
        length: 255,
    }),
    __metadata("design:type", String)
], Form.prototype, "apiName", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: form_strategy_1.FormStrategyEnum,
    }),
    __metadata("design:type", String)
], Form.prototype, "strategy", void 0);
__decorate([
    data_ui_1.DataUi.Override({ isFilter: false }),
    (0, typeorm_1.CreateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], Form.prototype, "createdAt", void 0);
__decorate([
    data_ui_1.DataUi.Override({ isFilter: false }),
    (0, typeorm_1.UpdateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], Form.prototype, "updatedAt", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.OneToMany)((type) => form_flow_1.FormFlow, (formFlow) => formFlow.form),
    __metadata("design:type", Array)
], Form.prototype, "formFlowSet", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.OneToMany)((type) => form_opportunity_1.FormOpportunity, (formOpportunity) => formOpportunity.form, {
        cascade: true,
    }),
    __metadata("design:type", Array)
], Form.prototype, "formOpportunitySet", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.OneToMany)(() => order_form_formula_mapping_1.OrderFormFormulaMapping, (item) => item.form, {
        cascade: true,
    }),
    __metadata("design:type", Array)
], Form.prototype, "formMappingSet", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.OneToMany)(() => form_lang_1.FormLang, (item) => item.form, {
        cascade: true,
    }),
    __metadata("design:type", Array)
], Form.prototype, "translations", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.OneToOne)(() => form_order_creation_strategy_1.FormOrderCreationStrategy, (item) => item.form, {
        cascade: true,
    }),
    __metadata("design:type", form_order_creation_strategy_1.FormOrderCreationStrategy)
], Form.prototype, "orderCreationStrategy", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.OneToOne)(() => form_order_modification_strategy_1.FormOrderModificationStrategy, (item) => item.form, {
        cascade: true,
    }),
    __metadata("design:type", form_order_modification_strategy_1.FormOrderModificationStrategy)
], Form.prototype, "orderModificationStrategy", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.OneToOne)(() => form_settings_1.FormSettings, (item) => item.form, {
        cascade: true,
    }),
    __metadata("design:type", form_settings_1.FormSettings)
], Form.prototype, "settings", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => form_import_1.FormImport, (item) => item.form, {
        cascade: true,
    }),
    __metadata("design:type", Array)
], Form.prototype, "formImports", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)('boolean', {
        nullable: false,
        name: 'active',
        default: true,
    }),
    __metadata("design:type", Boolean)
], Form.prototype, "active", void 0);
Form = Form_1 = __decorate([
    data_ui_1.DataUi.Permissions({
        read: [contact_profile_enum_1.ContactProfileEnum.PRODUCT, contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER],
        write: [contact_profile_enum_1.ContactProfileEnum.PRODUCT, contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER],
    }),
    data_ui_1.DataUi.Name({
        name: 'Form',
        nameProperties: ['name'],
    }),
    data_ui_1.DataUi.DefaultLayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Entity)('form', { schema: 'order_intake_forms' })
], Form);
exports.Form = Form;
//# sourceMappingURL=form.js.map